import usePaginatedFetch from "../core/usePaginatedFetch";

export const useUserTrades = ({
  userId = "zlwie-v4sln-i6tnp-pn4jk-wnfse-63wtg-7ogwu-2rrvl-m7ej5-a7rsd-cqe",
  limit = 10
}) => usePaginatedFetch(`/users/${ userId }/trades`, { limit });

export const useUserHoldings = (
  userId = "zlwie-v4sln-i6tnp-pn4jk-wnfse-63wtg-7ogwu-2rrvl-m7ej5-a7rsd-cqe",
  limit = 10
) => usePaginatedFetch(`/users/${ userId }/holdings`, { limit });

export const useUserTokens = ({
  userId = "zlwie-v4sln-i6tnp-pn4jk-wnfse-63wtg-7ogwu-2rrvl-m7ej5-a7rsd-cqe",
  limit = 10,
  tokens,
  start,
  end
}) => usePaginatedFetch(`/users/${ userId }/tokens`, { limit, tokens, start, end });

export const useUserAnalytics = (
  userId = "zlwie-v4sln-i6tnp-pn4jk-wnfse-63wtg-7ogwu-2rrvl-m7ej5-a7rsd-cqe",
  limit = 10
) => usePaginatedFetch(`/users/${ userId }/analytics`, { limit });

export const useUserList = (limit = 10, sortBy = "creator") =>
  usePaginatedFetch(`/users/leaderboard`, { limit, sortBy });

export const useUserBalances = (
  userId = "zlwie-v4sln-i6tnp-pn4jk-wnfse-63wtg-7ogwu-2rrvl-m7ej5-a7rsd-cqe",
  limit = 10,
  tokenIds
) => usePaginatedFetch(`/users/${ userId }/balance`, { limit, tokenIds });

export const useUserEpicDeposits = (timeRange = "1d", limit = 10) =>
  usePaginatedFetch(`/users/top-deposits`, { timeRange, limit });

export const useUserEpicWithdrawals = (timeRange = "1d", limit = 10) =>
  usePaginatedFetch(`/users/top-withdrawals`, { timeRange, limit });
